import { useSelector } from "react-redux";
import { DialogContent } from "@mui/material";
import { RootState } from "../../../redux/store";
import AddSewaCategory from "./sewa-category/AddSewaCategory";
import AddSewaDal from "./sewa-dal/AddSewaDal";
import SewaDeleteDialog from "./DeleteSewaCategory";
import AddSewa from "./sewa/AddSewa";
import AddSewaVolunteer from "./sewa-volunteer/AddSewaVolunteer";
import AddThemes from "./themes/AddThemes";
import ThemeStatusUpdate from "./themes/ThemeStatusUpdate";

const dialogsTypesWise: any = {

    "AddSewaCategory": () => <AddSewaCategory/>,
    "SewaDeleteDialog": () => <SewaDeleteDialog/>,
    "AddSewaDal": () => <AddSewaDal/>,
    "AddSewa": () => <AddSewa/>,
    "AddSewaVolunteer": () => <AddSewaVolunteer/>,
    "AddThemes": () => <AddThemes/>,
    "ThemeStatusUpdate": () => <ThemeStatusUpdate/>,
}

const dialogTypeFullScreen: any = { }

const SewaMasterPage: React.FC = () => {
    const { type, isFullScreen } = useSelector((state: RootState) => state.dialog);

    return (
        <>
            {
                (isFullScreen && dialogTypeFullScreen[type]?.()) ?
                    (
                        <DialogContent sx={{ height: "100%", margin: 0, padding: 0 }}  > {dialogTypeFullScreen[type]?.() ?? null} </DialogContent>
                    ) : (
                        <>
                            { dialogsTypesWise[type]?.() ?? null }
                        </>
                    )
            }
        </>
    )
}
export default SewaMasterPage;